import {BaseApiService} from "../../../infrastructure/domain-services/base-api-service";

export class EntityDescriptionApiService extends BaseApiService {}